import React from "react";

interface TabOption {
  value: string;
  label: string;
  icon: string;
}

interface TabsDropdownProps {
  activeTab: string;
  isOpen: boolean;
  toggleDropdown: () => void;
  handleTabChange: (tab: any) => void;
  options: TabOption[];
}

const TabsDropdown: React.FC<TabsDropdownProps> = ({
  activeTab,
  isOpen,
  toggleDropdown,
  handleTabChange,
  options,
}) => {
  const getActiveIcon = () => {
    const activeOption = options.find((option) => option.value === activeTab);
    return activeOption?.icon || "";
  };

  return (
    <div className="relative lg:hidden">
      <button
        onClick={toggleDropdown}
        className="flex items-center space-x-2.5 h-[35px] 2xl:h-[40px] px-3.5 2xl:px-4 rounded-[7px] bg-indigo-100/90 text-indigo-700 hover:bg-indigo-200/90 transition-colors duration-200"
      >
        <i
          className={`text-[15px] 2xl:text-[16px] fa-fw fa-solid ${getActiveIcon()}`}
        ></i>
        <span className="text-[14px] 2xl:text-[15px] tracking-wide capitalize">
          {activeTab}
        </span>
        <i
          className={`fa-solid fa-chevron-down text-[12px] 2xl:text-[13px] transition-all duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        ></i>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-52 2xl:w-56 bg-white rounded-xl shadow-lg py-1.5 z-50 border border-neutral-100/80">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                handleTabChange(option.value);
                toggleDropdown();
              }}
              className={`w-full px-4 py-2.5 text-left hover:bg-indigo-50 text-[14px] 2xl:text-[15px] flex items-center space-x-3 ${
                activeTab === option.value
                  ? "bg-indigo-50/80 text-indigo-700"
                  : "text-neutral-600"
              }`}
            >
              <i
                className={`fa-solid ${option.icon} text-[15px] 2xl:text-[16px] fa-fw`}
              ></i>
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TabsDropdown;
